import { HTMLFromRichText, PrismicLink, TextFromRichText } from './PrismicTypes';

export const CATEGORY_CARD = 'PrismicGenericTemplateDataBodyCardCollection';

export interface CategoryCardPrimary {
  card_collection_title?: TextFromRichText;
  card_collection_subtitle: HTMLFromRichText;
  card_collection_variant?: 'white' | 'grey' | 'mint';
}

export interface CategoryCardItem {
  card_description: TextFromRichText;
  card_title: TextFromRichText;
  primary_button_link: PrismicLink;
  primary_button_text: TextFromRichText;
  secondary_button_link: PrismicLink;
  secondary_button_text: TextFromRichText;
}

export interface CategoryCardContent {
  __typename: typeof CATEGORY_CARD;
  items: CategoryCardItem[];
  primary: CategoryCardPrimary;
}
